<template>
  <div class="cardPlate">
   <!-- 卡片折板 -->
   <div class="cardPlate-head">
     <div class="cardPlate-head-tit">{{title||'推荐商机'}}</div>
     <div class="cardPlate-head-right">
       <slot name="headMore"></slot>
     </div>
   </div>
   <div class="cardPlate-cont">
       <slot name="headCont"></slot>
   </div>
  </div>
</template>
<script>
export default {
  props: ['title'],
  data () {
    return {
    }
  },
  created () {
    
  },
  methods: {
  }
}
</script>
<style>
.cardPlate{
  background: #FFFFFF;
  border-radius: 5px;
  border-radius: 5px;
}
.cardPlate .mr8{
  margin-right: 8px;
}
.cardPlate .cardPlate-head{
  padding:0 16px;
  height: 48px;
  line-height: 48px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #DCDFE6;
}
.cardPlate .cardPlate-head .cardPlate-head-tit{
  color:#606266;
  font-weight: bold;
}
.cardPlate .cardPlate-head .cardPlate-head-right{
  color:#2E8AF1;
  font-size: 12px;
}
.cardPlate .cardPlate-head .cardPlate-head-right:hover{
  cursor: pointer;
}
.cardPlate-cont{
  padding:0 16px;
  margin-bottom: 15px;
}

.cardPlate-cont .list{
  padding-bottom:15px;
  margin-bottom: 0;
}
.cardPlate-cont .list li{
  display: flex;
  font-size: 12px;
  padding:15px 0;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  color:#303133;
  text-overflow: ellipsis;
  border-bottom: 1px dotted #E6E8EB;
}
.cardPlate-cont .list li:hover{
  background: #f0f2f5;
  color: #2E8AF1;
  cursor: pointer;
}
.cardPlate-cont .list li p{
  margin-bottom: 0;
}
.cardPlate-cont .list-more{
  margin-top: 10px;
  font-size: 12px;
  color: #2E8AF1;
  line-height: 18px;
  text-align: center;
}
.cardPlate-cont .list-more:hover{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/cardPlate.vue